module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iMEvL"))).then(() => parcelRequire('hEqeo'));